










import {Component, Prop, Vue} from 'vue-property-decorator';

import FilmDetails from '@/components/FilmDetails.vue'
import {bus} from "@/plugins/bus";
import { EventEmitter } from '@/interfaces/store-interfaces/event-emitter.interface';
import { Film } from '@/modules/Rhizome/interfaces/film.interface';

@Component({
  components: {
    FilmDetails,
  }
})

export default class FilmModal extends Vue {
  @Prop() filmId: string;

  mounted() {
    window.addEventListener("message", this.onModalMessage, false);
    document.body.style.overflow = 'hidden';
  }


  destroyed() {
    window.removeEventListener("message", this.onModalMessage);
    document.body.style.overflow = 'auto';

    // ensure screen saver is active after closing
    bus.$emit(EventEmitter.Events.SCREENSAVER_ACTIVE, true);      
  }

  get isKiosk() {
    return this.$store.state.rhizome.kioskMode;
  }

  close() {
    this.$store.dispatch('rhizome/closeFilmModal')
  }

  async onModalMessage(event) {
    if (event.origin === window.location.origin) {
      switch (event.data.action) {
        case 'close-modal':
          this.close()
          return
        case 'set-keyword':
          bus.$emit(EventEmitter.Events.SET_KEYWORD, event.data.payload as Film.IKeyword)
          this.close()
          return
        case 'set-film-active':
          bus.$emit(EventEmitter.Events.SET_KEYWORD, null)
          this.close()
          setTimeout(async () => {
            await this.$store.dispatch('rhizome/openFilmOnRhizome', { filmId: event.data.payload.id, query: { kiosk: true, force: Date.now() } , forceRefresh: true });
          }, 100)
          return
        case 'open-themes-modal':
          await this.$store.dispatch('rhizome/openThemesModal');
          return
      }
    }
  }
}
